/* mm-video-sparen.js — Videos laden erst, wenn sie gebraucht werden.
 *
 * 29.08.2026, Mert: "spare optimierung, wenn man nicht drauf schaut, und auch
 * wenn man drauf schaut ohne etwas zu zerstoeren, damit die seite schneller wird"
 *
 * GEMESSEN auf der Startseite, bevor es diese Datei gab:
 *   48 Video-Elemente · 59 Videodateien geholt · 26 MB nur Video
 *   Seite gesamt 33,6 MB bei 616 Anfragen
 *   39 dieser Videos standen NICHT auf `preload="none"`, hatten eine Quelle -
 *   und kein einziges davon war im Bild. Sie wurden also geladen, ohne dass
 *   jemand sie je zu sehen bekam.
 *   Eine einzige Datei wurde doppelt geholt: 11,7 MB + 9,4 MB.
 *
 * WAS DIESE DATEI TUT
 *   Sie nimmt jedem Video, das gerade nicht im Bild ist, die Quelle weg und
 *   merkt sie sich. Kommt das Video ins Bild, bekommt es sie zurueck. Damit
 *   laedt der Browser nur, was wirklich jemand sieht.
 *
 * WAS SIE BEWUSST NICHT ANFASST - damit nichts kaputtgeht:
 *   - Videos, die gerade LAUFEN. Wer ein Video gestartet hat, soll es behalten.
 *   - Videos, die schon einmal liefen (`currentTime > 0`). Sonst waere der
 *     Fortschritt weg, sobald man kurz wegscrollt.
 *   - Die Story-Leiste `#mmSE`. Die regelt ihre Vorschau selbst und haelt sich
 *     bereits an `preload="none"` - zweimal steuern hiesse gegeneinander steuern.
 *   - Alles mit `data-mm-spar="aus"`. Damit laesst sich jedes Video von Hand
 *     ausnehmen, falls doch einmal etwas klemmt.
 *   - Videos in einem offenen Dialog/Overlay (`:modal` oder sichtbarer Vorfahre
 *     mit `position:fixed`) - dort ist "nicht im Bild" kein verlaessliches Mass.
 *
 * Ein einziger Beobachter fuer alle Videos, kein Zeitgeber, keine Schleife.
 * Bei verstecktem Tab wird zusaetzlich pausiert (feste Regel 23.08.2026).
 */
(function () {
  'use strict';

  var VORLAUF = '600px';   /* so frueh laden, dass beim Hinscrollen nichts fehlt */
  var beobachter = null;
  var bekannt = new WeakSet();

  function ausgenommen(v) {
    if (v.dataset.mmSpar === 'aus') return true;
    if (v.closest('#mmSE')) return true;                 /* Story-Leiste regelt sich selbst */
    if (v.closest('dialog[open], .upcart-cart, #upCart')) return true;
    return false;
  }

  /* Schon benutzt? Dann nie anfassen - sonst verliert der Zuschauer die Stelle. */
  function inBenutzung(v) {
    return !v.paused || v.currentTime > 0 || v.ended;
  }

  function quelleMerken(v) {
    if (v.dataset.mmQuelle) return;                       /* schon gemerkt */
    var s = v.getAttribute('src');
    if (s) { v.dataset.mmQuelle = s; v.removeAttribute('src'); }
    var teile = [].slice.call(v.querySelectorAll('source[src]'));
    if (teile.length) {
      v.dataset.mmTeile = teile.map(function (q) { return q.getAttribute('src'); }).join('|');
      teile.forEach(function (q) { q.removeAttribute('src'); });
    }
    if (v.dataset.mmQuelle || v.dataset.mmTeile) {
      /* `load()` bricht einen laufenden Download ab - genau darum geht es. */
      try { v.load(); } catch (e) {}
    }
  }

  function quelleZurueck(v) {
    var etwas = false;
    if (v.dataset.mmTeile) {
      var werte = v.dataset.mmTeile.split('|');
      [].slice.call(v.querySelectorAll('source')).forEach(function (q, i) {
        if (werte[i]) q.setAttribute('src', werte[i]);
      });
      delete v.dataset.mmTeile; etwas = true;
    }
    if (v.dataset.mmQuelle) {
      v.setAttribute('src', v.dataset.mmQuelle);
      delete v.dataset.mmQuelle; etwas = true;
    }
    if (!etwas) return;
    try { v.load(); } catch (e) {}
    /* War es ein selbstlaufender Hintergrundfilm, laeuft er wieder an. */
    if (v.hasAttribute('autoplay') || v.dataset.mmLief === '1') {
      var l = v.play(); if (l && l.catch) l.catch(function () {});
    }
  }

  function pruefen(eintraege) {
    eintraege.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        quelleZurueck(v);
      } else if (!inBenutzung(v)) {
        if (v.getAttribute('preload') !== 'none') v.setAttribute('preload', 'none');
        quelleMerken(v);
      } else if (!v.paused) {
        /* Laeuft, ist aber aus dem Bild: anhalten und Stelle merken, die Quelle
           bleibt. Beim Zurueckscrollen geht es weiter, wo es war. */
        v.dataset.mmLief = '1';
        v.pause();
      }
    });
  }

  function aufnehmen() {
    var alle = document.querySelectorAll('video');
    for (var i = 0; i < alle.length; i++) {
      var v = alle[i];
      if (bekannt.has(v) || ausgenommen(v)) continue;
      bekannt.add(v);
      /* Vor dem ersten Blick nichts laden - das spart den Grossteil. */
      if (v.getAttribute('preload') !== 'none') v.setAttribute('preload', 'none');
      beobachter.observe(v);
    }
  }

  function start() {
    if (!('IntersectionObserver' in window)) return;      /* dann bleibt alles wie bisher */
    beobachter = new IntersectionObserver(pruefen, { rootMargin: VORLAUF });
    aufnehmen();

    /* Sektionen und Apps bauen nach - deshalb nachsehen, aber sparsam. */
    if (window.MutationObserver) {
      var wartet = false;
      new MutationObserver(function () {
        if (wartet) return;
        wartet = true;
        window.setTimeout(function () { wartet = false; aufnehmen(); }, 500);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    /* Tab im Hintergrund: nichts laeuft weiter. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) return;
      var alle = document.querySelectorAll('video');
      for (var i = 0; i < alle.length; i++) {
        var v = alle[i];
        if (ausgenommen(v) || v.paused) continue;
        v.dataset.mmLief = '1';
        v.pause();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
